import { Link } from "react-router-dom";
import { latestUpdates } from "@/mocks/comics";

export default function LatestUpdates() {
  const displayList = latestUpdates.slice(0, 12);

  return (
    <section className="w-full px-4 md:px-6 py-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-lg md:text-xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
              最新更新
            </h2>
            <p className="text-sm text-foreground-500 mt-1">每日同步更新，追更不迷路</p>
          </div>
          <Link to="/category/all" className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap cursor-pointer">
            全部作品 <i className="ri-arrow-right-line ml-1 text-xs"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-product-shop="true">
          {displayList.map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.slug}`}
              className="flex gap-4 p-4 rounded-xl bg-background-100 hover:bg-background-200/70 transition-colors group cursor-pointer"
            >
              <div className="w-20 h-28 flex-shrink-0 rounded-lg overflow-hidden">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  title={`${comic.title} - 韩国漫画免费在线观看`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="flex flex-col justify-between flex-1 min-w-0">
                <div>
                  <div className="flex items-center gap-2 mb-1">
                    <span className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 font-medium whitespace-nowrap">
                      {comic.categoryName}
                    </span>
                    {comic.status === "已完结" && (
                      <span className="text-xs px-2 py-0.5 rounded-full bg-background-200 text-foreground-600 whitespace-nowrap">
                        已完结
                      </span>
                    )}
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors truncate">
                    {comic.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-1 line-clamp-2">{comic.description}</p>
                </div>
                <div className="flex items-center justify-between mt-2">
                  <span className="text-xs text-foreground-400">{comic.author}</span>
                  <span className="flex items-center gap-1 text-xs text-foreground-400">
                    <i className="ri-eye-line"></i>
                    {formatViews(comic.views)}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

function formatViews(n: number): string {
  if (n >= 10000) return `${(n / 10000).toFixed(n % 10000 === 0 ? 0 : 1)}万`;
  return String(n);
}